import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core'
import { RouterLink } from '@angular/router'
import { ConfigService } from '../../services/config.service'
import { SidebarComponent } from '../sidebar/sidebar.component'
import { ResearchService } from '../../services/research.service'
import { TranslocoModule, TranslocoService } from '@jsverse/transloco'
import { StatisticsService } from '../../services/statistics.service'
import { NavigationService } from '../../services/navigation.service'
import { CommonModule } from '@angular/common'
@Component({
   selector: 'app-navigation',
   standalone: true,
   imports: [CommonModule, RouterLink, SidebarComponent, TranslocoModule],
   templateUrl: './navigation.component.html',
   // this host adds a 'contents' class, which more or less hides the element from the CSS hierarchy, making the flex box thing work properly
   // eslint-disable-next-line @angular-eslint/no-host-metadata-property
   host: {
      class: 'contents'
   }
})
export class NavigationComponent implements OnInit {

   get sideNavShowing() {
      return this.config.showSideNav
   }

   get showBeta() {
      return this.config.currentConfig.showBeta
   }

   labelSideNavToggleButton = ''

   // this make it so whatever button or link you click, it will close the sidebar (it is only set to true in mobile view, otherwise it is 'null')
   @HostListener('document:click')
   public onClick() {
      if (this.config.showSideNav === true) {
         this.config.toggleSideNav(null)
      }
   }

   @HostListener('keyup', ['$event'])
   keyEvent(event: KeyboardEvent) {
      if (event.key === 'Escape') {
         this.config.toggleSideNav(null)
      }
   }

   @ViewChildren('sidenavToggleButton') sidenavToggleButtons!: QueryList<ElementRef>

   constructor(private config: ConfigService,
      private research: ResearchService,
      private nav: NavigationService,
      private translocoService: TranslocoService,
      private stats: StatisticsService) { }

   ngOnInit() {
      this.setLabel()
   }

   hideNewSessionButton() {
      return this.nav.currentUrl === '/' || this.nav.currentUrl === '/research/new'
   }

   toggleSideNav(what?: boolean | null) {
      if (typeof what !== 'undefined') {
         this.config.toggleSideNav(what)
      }
      else {
         this.config.toggleSideNav(!this.config.showSideNav)
      }
      this.stats.sendEvent({ category: 'navigation', action: 'toggle-sidenav', label: 'open', value: ''+this.config.showSideNav })
      // this will focus the first visible toggle button in the sidebar, since there are multiple due to the responsive design
      setTimeout(() => {
         const currentlyVisibleToggleButton = this.sidenavToggleButtons.find((el) => el?.nativeElement?.checkVisibility() ?? false)
         if (currentlyVisibleToggleButton) {
            currentlyVisibleToggleButton.nativeElement.focus()
         }
      }, 50)
      this.setLabel()
   }

   toggleSideNavMobile() {
      if (this.config.showSideNav === true) {
         // set to 'null' since this is the 'third' state of the thing -
         this.config.toggleSideNav(null)
      }
      else {
         this.config.toggleSideNav(true)
      }
      this.stats.sendEvent({ category: 'navigation', action: 'toggle-sidenav-mobile', label: 'open', value: ''+this.config.showSideNav })

      this.setLabel()
   }

   startNewResearchSession() {
      this.research.startNewResearchSession()
      this.stats.sendEvent({ category: 'navigation', action: 'new-session', label: 'origin', value: 'header' })
   }

   setLabel() {
      this.translocoService.selectTranslate('sidebar.togglehide').subscribe((hide) => {
         this.labelSideNavToggleButton = hide

         if (this.sideNavShowing === false) {
            this.labelSideNavToggleButton = this.translocoService.translate('sidebar.toggleshow')
         }
      })
   }

}
